import 'promise-polyfill';
import 'whatwg-fetch';
import { debounce } from 'debounce';
import LoadContent from './modules/LoadContent';
import ToggleContent from './modules/ToggleMapOverlayContent';
import StartTour from './modules/StartTour';
import EnableTabbing from './modules/enableTabbing';
import BurgerMenu from './modules/BurgerMenu';
import CalculateTrueHeight from './modules/CalculateTrueHeight';
import ChatBotPopup from './modules/ChatbotPopup';
const loadContent = new LoadContent(document.getElementById('tour_container'));
const toggleContent = new ToggleContent(
    document.getElementById('toggle_content'),
);
const startTour = new StartTour(document.getElementById('start_tour'));
EnableTabbing();
BurgerMenu();
document.addEventListener('scroll', debounce(CalculateTrueHeight), false);
window.addEventListener('resize', debounce(CalculateTrueHeight), false);

ChatBotPopup();
